'use strict';

export default class ButtonToggle {
    constructor() {
        $('.js-toggle-table').on('click', function (e) {
            e.preventDefault();

            let $this = $(this),
                $table = $this.closest('.receipt--table'),
                $tableBody = $table.find('tbody');

            $this.toggleClass('active');
            $tableBody.fadeToggle();
        });
    }
}
